import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import Publish from './containers/publish';
import Report from './containers/report';
import BulkPublish from './containers/bulkPublish';
import LoginComponent from './components/login';
// import RegistrationComponent from './components/registration';
import AuthenticatedRoute from './authenticatedRoutes';

const RouteInfo = ({ store }) => (
  <Provider store={store}>
    <Router>
      <Switch>
        <Route path="/" component={LoginComponent} exact />
        {/* <Route path="/register" component={RegistrationComponent} /> */}
        <AuthenticatedRoute path="/publish" component={Publish} />
        <AuthenticatedRoute path='/report' component={Report} />
        <AuthenticatedRoute path='/bulkPublish' component={BulkPublish} />
        <AuthenticatedRoute path='/logout' action="logout" />
      </Switch>
    </Router>
  </Provider>
);

export default RouteInfo;